import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../../environments/environment";
import { getFeatureFlagBypassToken } from "../feature-flags/feature-flag-bypass.helper";

@Injectable()
export class FeatureFlagBypassInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = getFeatureFlagBypassToken();
    const isApiUrl = this.isApiUrlWithPathBoundary(request.url, environment.apiUrl);

    if (token && isApiUrl) {
      request = request.clone({
        setParams: { bypass_token: token }
      });
    }

    return next.handle(request);
  }

  private isApiUrlWithPathBoundary(requestUrl: string, apiUrl: string): boolean {
    try {
      const reqUrl = new URL(requestUrl);
      const envUrl = new URL(apiUrl);

      // Compare origins exactly (protocol + host).
      if (reqUrl.origin !== envUrl.origin) {
        return false;
      }

      // Check if the request pathname starts with the environment's pathname
      // and has a path boundary (slash or end of string).
      const envPathname = envUrl.pathname;
      const reqPathname = reqUrl.pathname;

      // If environment has no path (e.g., http://localhost:4200), any path on the same origin is OK.
      if (envPathname === '/' || envPathname === '') {
        return true;
      }

      // If environment has a path prefix (e.g., /QA or /PROD), enforce a path boundary.
      // Request must start with envPathname and be followed by / or end of string.
      return reqPathname === envPathname || reqPathname.startsWith(envPathname + '/');
    } catch {
      // If URL parsing fails, do not send the token.
      return false;
    }
  }
}
